
export const getButtonsModalByCode = (code, variantsButtons) => {

  let arrayButtonsVariant 
  variantsButtons.forEach((item) => {
    item.codes.forEach((codes) => {
        if(codes === code){
          arrayButtonsVariant = item.value
        }
    });
  });

  return  arrayButtonsVariant
}